/**
 * 클릭-주석 개발 오버레이(`agentation`)를 켜는 유일한 계정 — D102
 *
 * 소스에 개인 이메일을 리터럴로 남기지 않는다. 값은 빌드 시 `VITE_AGENTATION_ALLOWED_EMAIL`로
 * 주입된다(`.github/workflows/deploy-web.yml`) — `VITE_API_BASE_URL`과 같은 이유로, Vite가 빌드
 * 시점에 값을 번들에 그대로 인라인하므로 이 값도 결국 공개 산출물에 노출된다는 점은 같다.
 * 여기서 얻는 것은 소스·git 이력에서 리터럴을 빼는 것뿐이다.
 */
const AGENTATION_ALLOWED_EMAIL =
  import.meta.env.VITE_AGENTATION_ALLOWED_EMAIL?.trim().toLowerCase();

export function shouldShowAgentation(primaryEmail: string | null | undefined): boolean {
  if (!AGENTATION_ALLOWED_EMAIL) return false;
  return primaryEmail?.trim().toLowerCase() === AGENTATION_ALLOWED_EMAIL;
}
